import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const DocumentAnalyticsCell = ({
  count = 0
}) => /*#__PURE__*/_jsx(View, {
  textAlign: "right",
  children: count
});
export default DocumentAnalyticsCell;